import setSelfAdjustingInterval from 'self-adjusting-interval';
import { clearInterval, clearTimeout, setInterval, setTimeout } from 'worker-timers';

export default defineNuxtPlugin((nuxtApp) => {
    let time = null;

    function start(startTime) {
        if (time == null) {
            time = new Date(startTime.replace( /[-]/g, '/' ))
            time.setSeconds(time.getSeconds() - 1);
        }

        setInterval(function() {
            time.setSeconds(time.getSeconds() + 1);

            // console.log(time.toISOString())
            nuxtApp.$event.$emit('tick', time.toISOString());
        }, 1000);
    }

    return {
        provide: {
            tick: { 
                start
            }
        }
    }
});
